<form class="flex flex-col gap-6" [formGroup]="form" (ngSubmit)="save()" novalidate>
  @if (apiError()) {
    <app-error [apiError]="apiError()" />
  }

  <section
    class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
    <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
      <h2 class="title text-[18px] font-bold">
        {{ isArabic() ? "الحد الاقصى لطلب الصنف" : "Product Order Limit" }}
      </h2>
    </div>

    <div class="flex max-w-md flex-col gap-4">
      <div>
        <label class="labelColorText mb-1 block text-sm font-semibold">
          {{ isArabic() ? "حد الطلب للصنف" : "Product Order Limit" }}
        </label>
        <input
          type="text"
          inputmode="numeric"
          formControlName="orderLimitQuantity"
          [placeholder]="isArabic() ? 'ادخل حد الطلب من الصنف' : 'Enter product order limit'"
          [class]="inputClass('orderLimitQuantity')" />
        @if (errorOf("orderLimitQuantity"); as err) {
          <p class="errortextcolor mt-1 text-xs">{{ err }}</p>
        }
      </div>

      <div>
        <label class="labelColorText mb-1 block text-sm font-semibold">
          {{ isArabic() ? "فترة الحد" : "Order Limit Period" }}
        </label>
        <div [class]="daysWrapperClass()">
          <input
            type="text"
            inputmode="numeric"
            formControlName="orderLimitDays"
            [placeholder]="isArabic() ? 'ادخل فترة الحد' : 'Enter limit period'"
            class="placeholderColor w-full px-3 py-2 text-sm outline-none" />
          <span class="borderDivColor bgSoftGrayColor textHelpercolorone border-s px-3 py-2 text-xs">
            {{ isArabic() ? "أيام" : "Days" }}
          </span>
        </div>
        @if (errorOf("orderLimitDays"); as err) {
          <p class="errortextcolor mt-1 text-xs">{{ err }}</p>
        }
      </div>

      <div>
        <label class="labelColorText mb-1 block text-sm font-semibold">
          {{ isArabic() ? "ربط على قيمة الفاتورة" : "Linked to Invoice Value" }}
        </label>
        <input
          type="text"
          inputmode="decimal"
          formControlName="orderLimitTotalCash"
          [placeholder]="isArabic() ? 'ادخل قيمة الفاتورة' : 'Enter invoice value'"
          [class]="inputClass('orderLimitTotalCash')" />
        @if (errorOf("orderLimitTotalCash"); as err) {
          <p class="errortextcolor mt-1 text-xs">{{ err }}</p>
        }
      </div>
    </div>
  </section>

  <div class="flex items-center justify-end gap-3">
    <button
      type="button"
      (click)="cancel()"
      [disabled]="isSaving()"
      class="bgCancleColor cursor-pointer rounded-lg border px-8 py-2 text-sm font-semibold disabled:opacity-50">
      {{ isArabic() ? "إلغاء" : "Cancel" }}
    </button>
    <button
      type="submit"
      [disabled]="isSaving() || form.pristine"
      class="bgTabsColor cursor-pointer rounded-lg px-8 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50">
      {{ isArabic() ? (isSaving() ? "جارٍ الحفظ..." : "حفظ") : isSaving() ? "Saving..." : "Save" }}
    </button>
  </div>
</form>
